import { Component, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { ShareddtaService } from '@app/services/shareddta.service';
import { Router } from '@angular/router';
import { AuthServiceService } from '@app/services/auth-service.service';
import { DialogService } from '@app/services/dialog.service';
import { ToastService } from '@app/services/toast.service';
import { WarehouseService } from '@app/services/warehouse.service';
import { Observable, Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import { BreadcrumbService } from '@app/services/breadcrumb.service';
interface Warehouse {
  id: number;
  name: string;
  address: string;
  contactName: string;
  email: string;
  phoneNumber: string;
  alternatePhoneNumber: string;
  isActive: boolean;
}
@Component({
  selector: 'app-warehouse-list',
  templateUrl: './warehouse-list.component.html',
  styleUrl: './warehouse-list.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class WarehouseListComponent implements AfterViewInit {
  private warehouseSub?: Subscription;
  isLoading: boolean = true;
  // Pagination
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 0;

  // Warehouses data
  warehouses: Warehouse[] = [
    {
      id: 1,
      name: 'Crossroads C&I',
      address: '280 Belfield Road, Etobicoke, ON, Canada',
      contactName: 'Leanne Cumberbatch',
      email: 'lcumberbatch@crossroadsci.com',
      phoneNumber: '+1 647 295 6224',
      alternatePhoneNumber: '--',
      isActive: true
    },
    {
      id: 2,
      name: 'Crossroads C&I (Stoney Creek)',
      address: '590 South Service Road, Hamilton, ON, Canada',
      contactName: 'Mick',
      email: 'mick@crossroadsci.com',
      phoneNumber: '+1 905 643 9902',
      alternatePhoneNumber: '--',
      isActive: false
    },
    {
      id: 3,
      name: "Sandeep's Office Warehouse",
      address: 'City Business Center, National Highway 5, Phase 8B, Industrial Area, Sector 74, Mohali, Punjab, India',
      contactName: 'Sandeep Singh',
      email: 'sandeepbandral282@gmail.com',
      phoneNumber: '+91 910 318 5771',
      alternatePhoneNumber: '--',
      isActive: true
    },
    {
      id: 4,
      name: 'Toronto Central Warehouse',
      address: '100 King Street West, Toronto, ON M5X 1C7, Canada',
      contactName: 'John Smith',
      email: 'jsmith@warehouse.com',
      phoneNumber: '+1 416 555 1234',
      alternatePhoneNumber: '+1 416 555 5678',
      isActive: true
    },
    {
      id: 5,
      name: 'Vancouver Distribution Center',
      address: '456 Granville Street, Vancouver, BC V6C 1V3, Canada',
      contactName: 'Emily Chen',
      email: 'echen@distribution.com',
      phoneNumber: '+1 604 555 9876',
      alternatePhoneNumber: '--',
      isActive: false
    },
    {
      id: 6,
      name: 'Montreal Storage Facility',
      address: '789 Rue Saint-Jacques, Montreal, QC H3C 1G1, Canada',
      contactName: 'Pierre Dubois',
      email: 'pdubois@storage.com',
      phoneNumber: '+1 514 555 3456',
      alternatePhoneNumber: '+1 514 555 7890',
      isActive: true
    },
    {
      id: 7,
      name: 'Calgary Logistics Hub',
      address: '321 6th Avenue SW, Calgary, AB T2P 0R1, Canada',
      contactName: 'Sarah Johnson',
      email: 'sjohnson@logistics.com',
      phoneNumber: '+1 403 555 2468',
      alternatePhoneNumber: '--',
      isActive: true
    },
    {
      id: 8,
      name: 'Ottawa Fulfillment Center',
      address: '555 Wellington Street, Ottawa, ON K1A 0A6, Canada',
      contactName: 'Michael Brown',
      email: 'mbrown@fulfillment.com',
      phoneNumber: '+1 613 555 8642',
      alternatePhoneNumber: '+1 613 555 9753',
      isActive: false
    },
    {
      id: 9,
      name: 'Winnipeg Distribution Point',
      address: '222 Portage Avenue, Winnipeg, MB R3C 0B1, Canada',
      contactName: 'Jessica Wilson',
      email: 'jwilson@distribution.com',
      phoneNumber: '+1 204 555 1357',
      alternatePhoneNumber: '--',
      isActive: true
    },
    {
      id: 10,
      name: 'Edmonton Warehouse Complex',
      address: '888 Jasper Avenue, Edmonton, AB T5J 1P1, Canada',
      contactName: 'David Martinez',
      email: 'dmartinez@warehouse.com',
      phoneNumber: '+1 780 555 2461',
      alternatePhoneNumber: '+1 780 555 3692',
      isActive: true
    },
    {
      id: 11,
      name: 'Halifax Shipping Center',
      address: '111 Barrington Street, Halifax, NS B3J 1Z8, Canada',
      contactName: 'Amanda Taylor',
      email: 'ataylor@shipping.com',
      phoneNumber: '+1 902 555 7531',
      alternatePhoneNumber: '--',
      isActive: false
    },
    {
      id: 12,
      name: 'Regina Storage Solutions',
      address: '444 Victoria Avenue, Regina, SK S4N 0P7, Canada',
      contactName: 'Christopher Lee',
      email: 'clee@storage.com',
      phoneNumber: '+1 306 555 8520',
      alternatePhoneNumber: '+1 306 555 9641',
      isActive: true
    },
    {
      id: 13,
      name: 'Saskatoon Distribution',
      address: '777 2nd Avenue North, Saskatoon, SK S7K 2C5, Canada',
      contactName: 'Michelle White',
      email: 'mwhite@distribution.com',
      phoneNumber: '+1 306 555 1593',
      alternatePhoneNumber: '--',
      isActive: true
    },
    {
      id: 14,
      name: 'Victoria Logistics',
      address: '999 Government Street, Victoria, BC V8W 1X4, Canada',
      contactName: 'Robert Garcia',
      email: 'rgarcia@logistics.com',
      phoneNumber: '+1 250 555 7412',
      alternatePhoneNumber: '+1 250 555 8523',
      isActive: false
    },
    {
      id: 15,
      name: 'Quebec City Warehouse',
      address: '666 Grande Allée Est, Quebec City, QC G1R 2K5, Canada',
      contactName: 'Sophie Martin',
      email: 'smartin@warehouse.com',
      phoneNumber: '+1 418 555 9630',
      alternatePhoneNumber: '--',
      isActive: true
    }
  ];

  // Paginated data
  paginatedWarehouses: any[] = [];

  constructor(private router: Router, public warehouseService: WarehouseService, public authService: AuthServiceService, private toast: ToastService, private dialogService: DialogService, private shareddta: ShareddtaService, private breadcrumbService: BreadcrumbService) { }

  ngAfterViewInit(): void {
    this.shareddta.signalPageReady();
  }

  ngOnInit(): void {
    this.breadcrumbService.set([
      { label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6', action: () => this.goToDashboard() },
      { label: 'Warehouses' }
    ]);
    this.calculateTotalPages();
    this.updatePaginatedData();
    this.warehouseList(this.currentPage)
  }

  ngOnDestroy(): void {
    if (this.warehouseSub) {
      this.warehouseSub.unsubscribe();
    }
  }
  warehouse$!: Observable<object[]>;
  totalWarehouseCount: any;
  warehouseData: any;
  warehouseList(page?: any) {
    this.isLoading = true;
    this.warehouseSub?.unsubscribe();
    this.warehouseService.warehouseList(page);
    this.warehouse$ = this.warehouseService.getWarehouse();
    this.warehouseSub = this.warehouse$.pipe(skip(1)).subscribe((data: any) => {
      this.isLoading = false;
      this.totalWarehouseCount = data?.result?.count;
      this.warehouseData = data?.result?.results;
      this.totalPages = Math.ceil(this.totalWarehouseCount / this.itemsPerPage);
      this.warehouseData?.forEach((element: any, index: number) => {
        element['sNo'] = (index + 1) + (10 * (page - 1));
      });
    }, (error) => {
      this.isLoading = false;
      this.authService.dataError(error);
    });
  }
  // ============================================
  // PAGINATION METHODS
  // ============================================

  calculateTotalPages(): void {
    // this.totalPages = Math.ceil(this.warehouses.length / this.itemsPerPage);
    this.totalPages = Math.ceil(this.totalWarehouseCount / this.itemsPerPage);
  }

  updatePaginatedData(): void {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedWarehouses = this.warehouses.slice(startIndex, endIndex);
  }

  get paginationInfo(): string {
    const startItem = (this.currentPage - 1) * this.itemsPerPage + 1;
    const endItem = Math.min(this.currentPage * this.itemsPerPage, this.totalWarehouseCount);
    return `Showing ${startItem} – ${endItem} of ${this.totalWarehouseCount} Warehouses`;
  }

  get canGoPrevious(): boolean {
    return this.currentPage > 1;
  }

  get canGoNext(): boolean {
    return this.currentPage < this.totalPages;
  }

  previousPage(): void {
    if (this.canGoPrevious) {
      this.currentPage--;
      this.updatePaginatedData();
      this.warehouseList(this.currentPage)
    }
  }

  nextPage(): void {
    if (this.canGoNext) {
      this.currentPage++;
      this.updatePaginatedData();
      this.warehouseList(this.currentPage)
    }
  }

  // ============================================
  // UTILITY METHODS
  // ============================================

  getGlobalIndex(localIndex: number): number {
    return (this.currentPage - 1) * this.itemsPerPage + localIndex + 1;
  }

  formatPhoneForTel(phone: string): string {
    return phone.replace(/\s+/g, '');
  }

  hasPhone(phone: string | null | undefined): boolean {
    if (!phone) return false;

    const value = phone.trim().toLowerCase();

    return value !== '' && value !== '--' && value !== 'null';
  }




  // ============================================
  // ACTION METHODS
  // ============================================

  toggleActive(id: number): void {
    // const warehouse = this.warehouses.find(w => w.id === id);
    // if (warehouse) {
    //   warehouse.isActive = !warehouse.isActive;
    //   this.updatePaginatedData();
    //   console.log(`Toggled warehouse ${id} to ${warehouse.isActive ? 'Active' : 'Inactive'}`);

    //   // TODO: Call API to update warehouse status
    //   // this.warehouseService.updateStatus(id, warehouse.isActive).subscribe({
    //   //   next: () => console.log('Status updated'),
    //   //   error: (err) => console.error('Error updating status', err)
    //   // });
    // }

  }

  editWarehouse(id: number): void {
    console.log('Edit warehouse:', id);
    this.router.navigate(['admin/warehouse/edit', id]);
  }

  deleteWarehouse(id: number): void {
    const warehouse = this.warehouses.find(w => w.id === id);
    if (!warehouse) return;

    const confirmed = confirm(`Are you sure you want to delete "${warehouse.name}"?`);

    if (confirmed) {
      const index = this.warehouses.findIndex(w => w.id === id);
      this.warehouses.splice(index, 1);

      // Recalculate pagination
      this.calculateTotalPages();

      // Adjust current page if needed
      if (this.currentPage > this.totalPages && this.currentPage > 1) {
        this.currentPage = this.totalPages;
      }

      this.updatePaginatedData();

      console.log('Warehouse deleted successfully');

      // TODO: Call API to delete warehouse
      // this.warehouseService.delete(id).subscribe({
      //   next: () => console.log('Deleted successfully'),
      //   error: (err) => console.error('Error deleting warehouse', err)
      // });
    }
  }

  addWarehouse(): void {
    console.log('Navigate to add warehouse');
    this.router.navigate(['admin/warehouse/add']);
  }

  exportWarehouses(): void {
    console.log('Export warehouses to CSV/Excel');

    // TODO: Implement export functionality
    // this.warehouseService.export().subscribe({
    //   next: (blob) => {
    //     const url = window.URL.createObjectURL(blob);
    //     const a = document.createElement('a');
    //     a.href = url;
    //     a.download = 'warehouses.csv';
    //     a.click();
    //   },
    //   error: (err) => console.error('Error exporting', err)
    // });

    alert('Export functionality - implement CSV/Excel export here');
  }

  goToDashboard(): void {
    this.router.navigate(['/admin/dashboard']);
  }
  warehouseSet(id: any, val: any) {
    var formdata = new FormData();
    formdata.append('is_main_localation', val);
    this.warehouseService.warehouseSet(id).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        this.warehouseList(this.currentPage);
        this.toast.show('success', 'Warehouse Status Updated');
      },
      (error) => {
        this.toast.show('error', 'Failed to update');
        this.warehouseList(this.currentPage);
        this.authService.dataError(error);
      }
    );
  }
  async deleteOrder(warehouseId: any): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Delete Warehouse',
      'Are you sure you want to delete this warehouse? This action cannot be undone.',
      'Delete',
      'Cancel'
    );

    if (confirmed?.confirmed) {
      // console.log("FormData Value:", formdata.get('order_ids'));
      this.warehouseService.warehouseDelete(warehouseId).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }
          this.warehouseList(this.currentPage);
          this.toast.show('success', data.resultDescription);
        },
        (error: any) => {
          this.authService.dataError(error);
        }
      );
    }
  }
}
